import React from "react";
import { Incident, Unschedule } from "../../models/Incidents";
import { toCamelCase } from "../../hooks/toCameCase.tsx";

const isNocturnoShift = (shift?: string) =>
  String(shift || "").trim().toLowerCase() === "nocturno";

const PartnerDetails = ({ record }: { record: Incident }) => {
  const isFromDirectBoss = (record as any)._fromDirectBoss === true;
  const isNocturno =
    isNocturnoShift(record.schedule.partner?.candidate?.shift?.name) ||
    isNocturnoShift(record.schedule.shift);

  return (
    <div className="incidents-partner-details" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
      <span style={{ fontSize: "13px", fontWeight: "600" }}>
        {toCamelCase(
          `${record.schedule.partner.person.firstName} ${record.schedule.partner.person.lastName} ${record.schedule.partner.person.secondLastName}`
        )}
        {isNocturno && (
          <i
            className="fa-solid fa-moon ms-1 text-dark"
            title="Este colaborador tiene turno Nocturno registrado"
          ></i>
        )}
      </span>
      {isFromDirectBoss && (
        <span
          className="incidents-badge-boss"
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "4px",
            backgroundColor: "#ede9fe",
            color: "#7c3aed",
            fontSize: "10px",
            fontWeight: 600,
            padding: "2px 8px",
            borderRadius: "12px",
            marginTop: "3px",
          }}
        >
          <i className="fa-solid fa-user-tie" style={{ fontSize: "9px" }} />
          Revision como Jefe directo
        </span>
      )}
      <span className="text-secondary" style={{ fontSize: "11px", marginTop: "2px" }}>
        {record.schedule.positionName} - {record.schedule.shift}
      </span>
    </div>
  );
};

export default PartnerDetails;

export const PartnerDetailsUnschedule = ({
  record,
  showNightIcon,
}: {
  record: Unschedule;
  /** Sucursal con horario nocturno + turno RH «Nocturno». */
  showNightIcon?: boolean;
}) => {
  const isNocturno =
    showNightIcon ?? isNocturnoShift(record.partner.candidate?.shift?.name);

  return (
    <div className="incidents-partner-details" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
      <span style={{ fontSize: "13px", fontWeight: "600" }}>
        {toCamelCase(
          `${record.partner.person.firstName} ${record.partner.person.lastName} ${record.partner.person.secondLastName}`
        )}
        {isNocturno && (
          <i
            className="fa-solid fa-moon ms-1 text-dark"
            title="Este colaborador tiene turno Nocturno registrado"
          ></i>
        )}
      </span>
      <span className="text-secondary" style={{ fontSize: "11px", marginTop: "2px" }}>
        {record.partner.candidate.vacancy.position.name}
      </span>
    </div>
  );
};
